import { render } from "./Q4Detaille.vue?vue&type=template&id=795a36f4"
import script from "./Q4Detaille.vue?vue&type=script&lang=js"
export * from "./Q4Detaille.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__